import { Text, Center, Stack, Card } from "@mantine/core"

interface Props extends React.PropsWithChildren {
  title: string
  description?: React.ReactNode
}

export function AuthContainer({ title, description, children }: Props) {
  return (
    <Center h={"100%"}>
      <Card shadow="xs" withBorder miw={400} maw={"100%"}>
        <Stack p={"md"}>
          <Text ta={"center"} fw={"bold"} fz={"xl"}>
            {title}
          </Text>
          {description ? (
            typeof description === "string" ? (
              <Text>{description}</Text>
            ) : (
              description
            )
          ) : null}
          {children}
        </Stack>
      </Card>
    </Center>
  )
}
